import { z } from 'zod';
// ============================================================
// Common envelopes & pagination — shared across all admin APIs
// ============================================================
/**
 * Error envelope. Returned with any non-2xx HTTP status.
 * Success responses use the bare resource shape (no wrapper).
 * Audit log id (when relevant) is returned via response header `X-Audit-Log-Id`.
 */
export const ApiError = z.object({
    error: z.object({
        code: z.string(), // sub_code, e.g. 'invalid_credentials' | 'forbidden' | 'rate_limit_exceeded'
        message: z.string(),
        details: z.record(z.unknown()).optional(),
    }),
});
/**
 * Page request — used for all list endpoints.
 * Cursor pagination preferred for large data sets; offset for small admin lists.
 */
export const PageRequest = z.object({
    limit: z.number().int().min(1).max(200).default(50),
    offset: z.number().int().min(0).default(0),
});
/**
 * Page metadata returned in list responses.
 */
export const PageMeta = z.object({
    total: z.number().int(),
    limit: z.number().int(),
    offset: z.number().int(),
});
/**
 * Mutation reason — every admin mutation requires a free-text reason
 * (5-200 chars). Stored in audit_logs.reason. Sent via X-Admin-Reason header
 * OR within request body (server reads either; body wins if both present).
 */
export const MutationReason = z.string().min(5).max(200);
/**
 * Idempotency key — required on mutation endpoints.
 * Sent via Idempotency-Key header. Server caches response 24h on (key, admin_id).
 */
export const IdempotencyKey = z.string().min(8).max(128);
/**
 * ISO 8601 timestamp string. Always UTC.
 */
export const IsoDateTime = z.string();
//# sourceMappingURL=_common.js.map